import { useApi } from '../../hooks';
import { useQuery } from '@tanstack/react-query';

export type SubscriptionPath = {
  subscription_path: 'eligibility-check' | 'out-of-pocket' | 'book-a-call';
};

export const useSubscriptionPath = ({
  userId,
  enable = true,
  onSuccess,
}: {
  userId?: string;
  enable?: boolean;
  onSuccess?: (data: SubscriptionPath) => void;
}) => {
  const { api } = useApi();

  const getCheckEligibleStatus = async (): Promise<SubscriptionPath> => {
    return api({
      route: `/user/subscription-path?user_id=${userId}`,
    });
  };

  const { data, isLoading, isError, refetch } = useQuery<
    SubscriptionPath,
    Error
  >({
    queryKey: ['subscription-path', userId],
    queryFn: getCheckEligibleStatus,
    enabled: !!userId && !!enable,
    cacheTime: 0,
    onSuccess,
  });

  return {
    isLoading,
    isError,
    data,
    refetch,
  };
};
